import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import { faAngleRight, faAngleLeft, faArrowLeft, faArrowRight, faLongArrowRight, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faGlobe, faCheck, faFileAlt, faFilePdf, faFileWord, faFileExcel, faFileImage, faFileArchive, } from '@fortawesome/pro-light-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
// Build icon library
library.add(faAngleRight, faAngleLeft, faArrowLeft, faArrowRight, faLongArrowRight, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faGlobe, faCheck, faFileAlt, faFilePdf, faFileWord, faFileExcel, faFileImage, faFileArchive, faFacebook, faInstagram);
// Register fa-icon component globally
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);
export default library;
